<template>
	<div
		:class="[
			'offer',
			{'is-checked': offer.isChecked},
			{'is-disabled': offer.isDisabled},
			{'is-rebel-disabled': offer.type ==='partner' && offer.isDisabled && offer.url},
			'gtm-offer-'+offer.id,
		]"
	>

			<div class="offer__inner">
				<div class="offer__img-container">
					<div
							class="offer__img"
							:style="imgStyleObject"
					>
						<img
								class="visually-hidden"
								:src="offer.img"
								:alt="offer.title"
						>
					</div>
				</div>
				<div class="offer__txt-container">
					<div class="offer__txt">{{offer.title}}</div>
					<div v-if="offer.description" class="offer__description" :style="[ offer.isFanOffer ? { 'height': 'inherit' } : null ]">{{ offer.description}}</div>
					<div v-if="offer.age" class="offer__agerange"> For Ages {{ offer.age }}</div>
					<div v-else v-bind:class="emptyAge" class="offer__agerange"> For Ages {{ offer.age }}</div>
					<div v-if="offer.offtype ==='club'">
						<div class="offer__checkwrapper">
							<div class="offer__checkbox"></div>
							<span class="offer__redeem"> Redeem </span>
							<span v-if="currentRoute() === true">
								<span v-if="offer.isChecked" class="offer__redeemselectedcheck"> Selected </span>
								<span v-if="offer.isDisabled" class="offer__redeemselectedred"> Selected </span>
							</span>
							<span v-else class="offer__redeemselected"> Selected </span>
						</div>
				    </div>
					<div v-if="offer.offtype ==='partner'" class="offer__rebel-offer-link-button">
						<div v-if="currentRoute() === true">
						  	<div v-if="offer.url && offer.isDisabled">
								<div class="offer__checkwrapper">
									<a
										class="btn btn--sm bottom-gap-sm"
										v-on:click= "openLink(); "
									>
										<span v-if="offer.id === 1">Visit
											<span class="offer rebel-text gtm-offer-visit-rebel">rebel</span>
										</span>
										<span v-if="offer.id === 24" class="gtm-offer-donate">DONATE</span>
										<span v-else class="offer partner-text">View Offer</span></a>
								</div>
							</div>
							<div v-else class="offer__no-link">
								<div class="offer__checkwrapper">
									<div class="offer__checkbox"></div>
									<span v-if="offer.id === 24 && !offer.isChecked" class="offer__redeem">SUPPORT</span>
									<span v-else-if="offer.id === 24 && offer.isChecked" class="offer__redeemselected">SUPPORT</span>
									<span v-else-if="offer.id === 25 && !offer.isChecked" class="offer__redeem">REGISTER</span>
									<span v-else-if="offer.id === 25 && offer.isChecked" class="offer__redeemselected">REGISTERED</span>
									<span v-else-if="offer.id === 26 && offer.isChecked" class="offer__redeemselected">REDEEMED</span>
									<span v-else-if="offer.id === 27 && offer.isChecked" class="offer__redeemselected">REDEEMED</span>
									<span v-else-if="offer.id === 28 && !offer.isChecked" class="offer__redeem">ENTER</span>
									<span v-else-if="offer.id === 28 && offer.isChecked" class="offer__redeemselected">ENTERED</span>
									<span v-else-if="offer.isChecked" class="offer__redeemselected"> Selected</span>
									<span v-else class="offer__redeem gtm-offer-redeem"> Redeem </span>
								</div>
							</div>
						</div>
						<div v-else class="offer__no-link">
							<div class="offer__checkwrapper">
								<div class="offer__checkbox"></div>
								<span v-if="offer.id === 24 && !offer.isChecked" class="offer__redeem">SUPPORT</span>
								<span v-else-if="offer.id === 24 && offer.isChecked" class="offer__redeemselected">SUPPORT</span>
								<span v-else-if="offer.id === 25 && !offer.isChecked" class="offer__redeem">REGISTER</span>
								<span v-else-if="offer.id === 25 && offer.isChecked" class="offer__redeemselected">REGISTERED</span>
								<span v-else-if="offer.id === 28 && !offer.isChecked" class="offer__redeem">ENTER</span>
								<span v-else-if="offer.id === 28 && offer.isChecked" class="offer__redeemselected">ENTERED</span>
								<span v-else-if="offer.isChecked" class="offer__redeemselected gtm-offer-selected"> Selected</span>
								<span v-else class="offer__redeem"> Redeem </span>
								
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
	export default {
    props: {
      offer: {
        required: true
      }
    },
    computed: {
      imgStyleObject() {
        return this.offer.img ? {
          backgroundImage: `url('${this.offer.img}')`
        } : {};
      },
      emptyAge() {
        let classAge = 'offer__no-age visually-hidden';
        return classAge;
      }
    },
    methods: {
      openLink: function () {
        window.open(this.offer.url, "_blank");
      },
      offersPath: function () {
        return this.$route.path === 'offers';
      },
      currentRoute() {
        return this.$route.path === '/my-account';
      }
    },
  };
</script>

<style lang="scss">
	@import "~sass/_config.scss";
	@import '~sass/_variables.scss';
	@import "~sass/mixins/_media-query.scss";

	.offer {
    $b: &;

    position: relative;
    width: 100%;

    &__inner {
      background-color: $col-neutral--0;
      border: 1px solid $col-neutral--3;
      transition: background-color $ttime;
      display: flex;
      min-height: 160px;
    }

    &__checkbox {
      display: block;
      position: absolute;
      top: 15px;
      right: 15px;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 1px solid $col-neutral--3;
      background-color: $col-neutral--0;
      overflow: hidden;
      transition: background-color, border-color;
      transition-duration: $ttime;

      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 9px;
        height: 3px;
        border-left: 3px solid $col-neutral--0;
        border-bottom: 3px solid $col-neutral--0;
        top: 45%;
        left: 110%;
        transform: translateX(-50%) translateY(-50%) rotate(-45deg);
        transition: left $ttime;
      }
    }

    &__img-container {
      width: 50%;
    }

    &__txt-container {
      position: relative;
      width: 50%;
      padding: 3% 40px 3% 3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__img {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      /*background-position: 50% 50%; */
    }

    &__txt {
      color: $col-neutral--8;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
    }

    &__description {
      font-size: 14px;
      line-height: 18px;
      color: $col-neutral--6;
    }

    &__rebel-offer-link-button {
      margin-top: 10px;

      & a {
        pointer-events: visible;
      }
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      box-shadow: 0 3px 6px rgba($col-neutral--9, 0.16);
      opacity: 0;
      transition: opacity $ttime;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: $col-neutral--0;
      opacity: 0;
      transition: opacity $ttime;
    }

    &.is-checked {
      #{$b}__inner {
        background-color: $col-neutral--1;
      }

      #{$b}__checkbox {
        background-color: $col-positive--1;
        border-color: $col-positive--1;

        &::before {
          left: 50%;
        }
      }

      &::before {
        opacity: 1;
      }
    }

    &.is-disabled {
      pointer-events: none;

      &::after {
        opacity: 0.6;
      }
    }

    &.is-rebel-disabled {
      pointer-events: none;

      &::after {
        opacity: 0;
      }
    }

    &.rebel-text {
      text-transform: lowercase;
      font-size: 12pt;
    }


    &:hover {
      cursor: pointer;

      #{$b}__inner {
        background-color: $col-neutral--1;
      }
    }

    @include mq(largeMobile) { // min-width: 660px
      &__txt {
        font-size: 16px;
        line-height: 18px;
      }

      &__description {
        font-size: 16px;
        line-height: 20px;
      }
    }

    @include maxq(tablet) { // max-width: 760px
      &__img-container {
        width: 100%;
      }

      &__txt-container {
        width: 100%;
      }

      &__inner {
        flex-direction: column;
        min-height: inherit;
      }

      &__img {
        padding-bottom: 38%;
      }
    }
  }
</style>

